module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b064ac23094b192d4e68a8eee99e7bf9.png";